// extracted by mini-css-extract-plugin
export default {"control":"BlockchainControl_control__Qx6o4"};